<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ct" id="toc_marker-4">Dedication</p>
<p class="Body-Center"><span class="Italic">Like all the others before, <br/>this is dedicated to my family.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// High_Stakes-3.vue?1f89d026